export default __webpack_public_path__ + "static/media/background.f1e8eeb0.png";